(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cout-achat-eau', {
            parent: 'entity',
            url: '/cout-achat-eau?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.coutAchatEau.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/cout-achat-eau/cout-achat-eaus.html',
                    controller: 'CoutAchatEauController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('coutAchatEau');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cout-achat-eau-detail', {
            parent: 'entity',
            url: '/cout-achat-eau/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.coutAchatEau.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/cout-achat-eau/cout-achat-eau-detail.html',
                    controller: 'CoutAchatEauDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('coutAchatEau');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CoutAchatEau', function($stateParams, CoutAchatEau) {
                    return CoutAchatEau.get({id : $stateParams.id});
                }]
            }
        })
        .state('cout-achat-eau.new', {
            parent: 'cout-achat-eau',
            url: '/new',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cout-achat-eau/cout-achat-eau-dialog.html',
                    controller: 'CoutAchatEauDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dateAjout: null,
                                cout: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cout-achat-eau', null, { reload: true });
                }, function() {
                    $state.go('cout-achat-eau');
                });
            }]
        })
        .state('cout-achat-eau.edit', {
            parent: 'cout-achat-eau',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cout-achat-eau/cout-achat-eau-dialog.html',
                    controller: 'CoutAchatEauDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CoutAchatEau', function(CoutAchatEau) {
                            return CoutAchatEau.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('cout-achat-eau', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cout-achat-eau.delete', {
            parent: 'cout-achat-eau',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cout-achat-eau/cout-achat-eau-delete-dialog.html',
                    controller: 'CoutAchatEauDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CoutAchatEau', function(CoutAchatEau) {
                            return CoutAchatEau.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('cout-achat-eau', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
